import React from "react";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    id: "02",
    title: "The best tech stack for building a mobile app",
    date: "2026-10-22",
  },
  {
    id: "01",
    title: "I built an AI integration in 1 weekend",
    date: "2026-10-18",
  },
];

function Blog() {
  return (
    <section className="blog-section">
      <h2>Blog</h2>
      <p>
        <em>All posts are written without the use of AI</em>
      </p>
      <ul className="blog-list">
        {blogPosts.map((post) => (
          <li className="blog-item" key={post.id}>
            <Link className="blog-title" to={`/blog/${post.id}`}>
              {post.title}
            </Link>
            <span className="blog-date">
              {new Date(`${post.date}T00:00:00`).toLocaleDateString()}
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Blog;
